<template>
    <div>
        <v-container class="toggle animated" fluid>
            <v-row dense>
                <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    :label="$t('TableHeaders.Search')"
                    density="comfortable"
                    solo
                    hide-details
                    class="rounded-lg"
                    color="white"
                    style="font-family: Saira Condensed, sans-serif;"></v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" md="2">
                    <v-select
                    v-model="selectedStatus"
                    @update:model-value="sortByStatus()"
                    variant="outlined"
                    :label="$t('TableHeaders.Status')"
                    density="comfortable"
                    hide-details
                    class="rounded-lg"
                    :items="status"
                    item-title="title"
                    item-value="value"
                    style="font-family: Saira Condensed, sans-serif;"
                    ></v-select>
                </v-col> 
                <!-- <v-col class="text-right" cols="12" md="8">
                    <v-btn
                    @click="showAddDialog()"
                    prepend-icon="mdi-plus"
                    class="mt-2 rounded-lg"
                    color="primary"
                    height="40px"
                    elevation="2" style="font-family: Saira Condensed, sans-serif;">
                        Add Product
                    </v-btn>
                </v-col> -->
                <v-col cols="12">
                    <v-expansion-panels multiple color="primary">
                        <v-expansion-panel class="guide-panel">
                            <v-expansion-panel-title class="font-weight-bold">
                                📌 PURCHASES STATUS GUIDE
                            </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-list class="guide-panel-content text-subtitle-2" dense>
                                <v-list-item>
                                    ➤ ”PENDING” - INITIAL STATUS WHERE A USER JUST PURCHASED SOMETHING FROM THE VIRTUAL STORE
                                </v-list-item>
                                <v-list-item>
                                    ➤ “IN PROGRESS“ - ADMIN CAN CHANGE THE STATUS TO IN PROGRESS IF IT IS ON QUEUE FOR VALIDATION
                                </v-list-item>
                                <v-list-item>
                                    ➤ “COMPLETED“ - ADMIN CAN CHANGE THE STATUS TO COMPLETED IF THE TRANSACTION IS SUCCESSFULLY VALIDATED FOR BOTH PARTIES
                                </v-list-item>
                                <v-list-item>
                                    ➤ “DECLINED“ - ADMIN HAS TO BE VERY CAREFUL IN USING THIS STATUS. THIS SIMPLY DECLINES A PURCHASE AND DOES NOT ISSUE A REFUND.
                                </v-list-item>
                                <v-list-item>
                                    ➤ REFUND ICON - ISSUE A REFUND IF THE ADMIN DECIDES TO REFUND THE POINTS TO THE USER. NO OTHER STATUS CAN BE USED AFTER CLICKING REFUND.
                                </v-list-item>
                            </v-list>
                        </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
                <v-col cols="12">
                    <v-card class="dt-container mt-2">
                        <v-data-table
                            :mobile="isMobileOrTablet()"
                            :headers="headers"
                            :items="data"
                            :search="search"
                            :loading="loading"
                            class="text-subtitle-1"
                            style="font-family: Saira Condensed, sans-serif;"
                        >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                <!-- <v-skeleton-loader type="table-row@10"></v-skeleton-loader> -->
                            </template>

                            <template v-slot:item.status="{ item }">
                                <v-chip v-if="item.status == 'pending'" color="orange">
                                    <span>Pending</span>
                                </v-chip>
                                <v-chip v-if="item.status == 'inprogress'" color="blue">
                                    <span>Inprogress</span>
                                </v-chip>
                                <v-chip v-if="item.status == 'completed'" color="green">
                                    <span>Completed</span>
                                </v-chip>
                                <v-chip v-if="item.status == 'refunded'" color="gray">
                                    <span>Refunded</span>
                                </v-chip>
                                <v-chip v-if="item.status == 'declined'" color="red">
                                    <span>Declined</span>
                                </v-chip>
                            </template>

                            <template v-slot:item.user.isVerified="{ item }">
                                <v-chip v-if="item.user.isVerified == true" color="green">
                                    <span>✔</span>
                                </v-chip>
                                <v-chip v-else color="red">
                                    <span>✘</span>
                                </v-chip>
                            </template>

                            <template v-slot:[`item.action`]="{ item }">
                                    <v-icon
                                        v-if="item.status == 'pending' || item.status == 'inprogress'"
                                        @click="showRefundDialog(item)"
                                        class="me-2"
                                        size="small"
                                    >
                                    mdi-credit-card-refund
                                    </v-icon>
                                    <v-icon
                                        @click="showVieWDialog(item)"
                                        class="me-2"
                                        size="small"
                                    >
                                    mdi-eye
                                    </v-icon>
                                    <!-- <v-icon
                                    @click="showEditDialog(item)"
                                    class="me-2"
                                    size="small"
                                >
                                    mdi-pencil
                                    </v-icon> -->
                                
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="refundDialog" width="450" persistent>
            <v-card color="primary" rounded="lg" class="pa-2" style="font-family: Saira Condensed, sans-serif;">
                <v-card-text class="font-weight-bold">
                    Are you sure you want to refund points and cancel purchase for this product ?
                    <br><br>Transaction Code: {{ itemToRefund.ticketNumber}}
                    <br>Product: {{ itemToRefund.product.title}}
                    <br>User: {{ itemToRefund.user.username}}
                </v-card-text>
                <template v-slot:actions>
                <v-spacer></v-spacer>

                <v-btn @click="refundDialog = false" :disabled="loadingRefund" variant="outlined">
                    {{ $t('Buttons.Cancel') }}
                </v-btn>
                <v-btn @click="refundItem()" :loading="loadingRefund" color="secondary" variant="elevated">
                    {{ $t('Buttons.Confirm') }}
                </v-btn>
                </template>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackbar"
            :timeout="2500"
            color="secondary"
            location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
        </v-snackbar>

        <PurchaseViewDialog ref="PurchaseViewDialog" v-on:refresh="sortByStatus()"></PurchaseViewDialog>
    </div>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import PurchaseViewDialog from '../Dialogs/Views/PurchaseViewDialog.vue';

export default defineComponent({
    components: {
        PurchaseViewDialog
    },
    data(){
        return {
            data: [],
            refundDialog: false,
            itemToRefund: null,
            loadingRefund: false,
            search: null,
            loading: false,
            selectedStatus: 'all',
            headers: [
                { title: this.$t('TableHeaders.PurchaseTicket'), align: 'start', sortable: true, key: 'ticketNumber' },
                { title: this.$t('TableHeaders.User'), align: 'start', sortable: true, key: 'user.displayName' },
                { title: this.$t('TableHeaders.Product'), align: 'start', sortable: true, key: 'product.title' },
                { title: this.$t('TableHeaders.Points'), align: 'start', sortable: true, key: 'amount' },
                { title: this.$t('TableHeaders.Status'), align: 'start', sortable: true, key: 'status' },
                { title: this.$t('TableHeaders.IsVerified'), align: 'start', sortable: true, key: 'user.isVerified' },
                { title: this.$t('TableHeaders.Actions'), align: 'end', sortable: false, key: 'action' },
            ],
            status: [
                { title: 'All', value: 'all' },
                { title: 'Pending', value: 'pending' },
                { title: 'Inprogress', value: 'inprogress' },
                { title: 'Completed', value: 'completed' },
                { title: 'Declined', value: 'declined' },
                { title: 'Cancelled', value: 'cancelled' },
                { title: 'Refunded', value: 'refunded' },
            ],

            snackbar: false,
            snackText: null,
        }
    },
    methods: {
        init(){
            const token = localStorage.getItem('abughazi-admin-accesstoken')
            if(token){
                this.loading = true
                axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/store/purchases',
                { headers: 
                    { 
                        'Authorization': `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                }
                ).then((res)=>{
                    if(res){
                        this.data = res.data.purchases
                        this.loading = false
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("abughazi-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
            else{
                localStorage.removeItem("vuex");
                localStorage.removeItem("abughazi-admin-accesstoken");
                window.location.reload();
            }
        },
        refundItem(){
            const token = localStorage.getItem('abughazi-admin-accesstoken')
            this.loadingRefund = true
            let formData = {
                userId: this.itemToRefund.user._id,
                transactionCode: this.itemToRefund.transactionCode
            }
            axios.post(process.env.VUE_APP_SERVER_URL + '/api/admin/points/refund', formData,{ 
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                }
            }).then((res)=>{
                if(res){
                    this.init()
                    this.snackbar = true
                    this.snackText = 'Points successfully refunded!'
                    this.loadingRefund = false
                    this.refundDialog = false
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("abughazi-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                } 
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        },
        sortByStatus() { 
            if (this.selectedStatus == 'all') {
                this.init()
            }
            else {
                this.loading = true
                const token = localStorage.getItem('abughazi-admin-accesstoken')
                axios.get(process.env.VUE_APP_SERVER_URL + '/api/admin/store/purchases?status=' + this.selectedStatus, { 
                    headers: { 
                        'Authorization': `Bearer ${token}`,
                        'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                    }
                }).then((res)=>{
                    if(res){
                        this.data = res.data.purchases
                        this.loading = false
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("abughazi-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            }
            
        },
        showVieWDialog(data){
            this.$refs.PurchaseViewDialog.initView(data)
        },
        showRefundDialog(data){
            this.itemToRefund = data
            this.refundDialog = true
        }
    },
    mounted(){
        this.init()
    }
}) 
</script>

<style scoped>

</style>